<template>
<div class="myIndex">
    <div class="userInfo">
        <!-- 个人信息 -->
        <div class="user">
            <div class="user_l">
                <div class="thumb" @click="goPage('/set/account')">
                    <img :src="info.thumb ? ($publicData.withHttpStart(info.thumb) ? info.thumb : imageUrl+info.thumb) : $publicData.defaultTouxiang" alt />
                </div>
                <div class="info">
                    <div class="info_t" v-if="token">
                        <div class="user_name slh_s">{{ info.nickname}}</div>
                        <div class="user_tle">{{ info.username }}</div>
                        <!-- <div class="user_name slh_s">{{ info.nickname ? info.nickname : info.users.username }}</div> -->
                        <!-- <div class="user_tle" v-if="info.nickname">{{ info.users.username }}</div> -->
                    </div>
                    <div class="info_t" v-if="!token">
                        <div class="user_name slh_s" @click="goPage('login')">登录</div>
                    </div>
                    <div class="info_b" v-if="userrole.is_agent != 1 || userrole.is_partner != 1 || userrole.is_seller != 1 || userrole.is_tradesman != 1" @click="goPage('/cooperation/transition')">申请合作</div>
                    <!-- <div class="info_b" @click="goPage('cooperation-transition')">申请合作</div> -->
                </div>
            </div>
            <div class="user_r">
                <div class="icon_setup" @click="goPage('/set/index')"></div>
            </div>
        </div>
        <!-- 收藏 关注 粉丝 -->
        <div class="mark">
            <div class="item" @click="goPage('/collect/index')">
                <div class="num">{{token&&nums.collectAll ? nums.collectAll : 0}}</div>
                <div class="txt">收藏</div>
            </div>
            <div class="item" @click="goPage('/follow/index')">
                <div class="num">{{token&&nums.attention ? nums.attention : 0}}</div>
                <div class="txt">关注</div>
            </div>
            <div class="item" @click="goFensi">
                <div class="num">{{token&&nums.attentioner ? nums.attentioner: 0 }}</div>
                <div class="txt">粉丝</div>
            </div>
			<div class="item" @click="goPage('/my/zuji')">
                <div class="num">{{token&&nums.lookrecordnum ? nums.lookrecordnum: 0 }}</div>
                <div class="txt">足迹</div>
            </div>
        </div>
        <!-- 余额 -->
        <div class="money">
            <div class="item">
                <span>余额:</span>
                <span class="num">￥{{token&&useraccount.user_money ? useraccount.user_money : 0}}</span>
            </div>
            <div class="item" @click="goPage('/set/card')">
                <span class="card num">￥{{token&&cardMoney ? cardMoney : 0}}</span>
            </div>
			<div class="item" @click="goPage('/my/jifen')">
				<span>积分:</span>
				<span class="num">{{ token && useraccount.new_points ? useraccount.new_points : 0 }}</span>
			</div>
        </div>
    </div>
    <!--  -->
    <div class="con">
        <!-- 订单 -->
        <div class="order" :name="ordertab">
            <div class="top">
                <div class="tabs">
                    <span class="tab active" name="a" @click="changeTab('a')">
						<span class="">商城订单</span>
						<span class="tag" v-if="token && (unpay_num != 0 || unship_num !=0|| unreceipt_num !=0)"></span>
					</span>
					<span class="tab" name="c" @click="changeTab('c')">
						<span class="">定制订单</span>
						<span class="tag" v-if="token && (unpay_madeorders != 0 || made_madeorders != 0 || unfinal_madeorders != 0 || unship_madeorders != 0 )"></span>
					</span>
					<!-- 不再区分云订单  2022年5月9号 -->
                    <!-- <span class="tab" name="b" @click="changeTab('b')">
						<span class="">云订单</span>
						<span class="tag" v-if="token && yunNum && (yunNum.unpay_num != 0 || yunNum.unship_num != 0 || yunNum.unreceipt_num != 0)"></span>
					</span> -->
                </div>
                <span class="more" v-if="ordertab != 'c'" @click="orderList(0)">全部订单</span>
				<span class="more" v-if="ordertab == 'c'" @click="orderDingzhiList(1)">全部订单</span>
            </div>
            <div class="nr">
                <div class="txt active" name="a">
                    <ul class="actions">
                        <li class="item" @click="orderList(1)">
                            <img :src="this.publicPath+'statics/images/my/icon_wallet.png'" class="item_icon" alt="">
                            <div class="item_txt">待支付</div>
                            <div class="num" v-if="token && unpay_num!=0">{{unpay_num}}</div>
                        </li>
                        <li class="item" @click="orderList(2)">
                            <img :src="this.publicPath+'statics/images/my/icon_fahuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待发货</div>
                            <div class="num" v-if="token && unship_num!=0">{{unship_num}}</div>
                        </li>
                        <li class="item" @click="orderList(3)">
                            <img :src="this.publicPath+'statics/images/my/icon_shouhuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待收货</div>
                            <div class="num" v-if="token && unreceipt_num!=0">{{ unreceipt_num }}</div>
                        </li>
                        <li class="item" @click="orderList(4)">
                            <img :src="this.publicPath+'statics/images/my/icon_comment.png'" class="item_icon" alt="">
                            <div class="item_txt">待评论</div>
                        </li>
                        <li class="item" @click="afterSaleList(5)">
                            <img :src="this.publicPath+'statics/images/my/icon_aftersale.png'" class="item_icon" alt="">
                            <div class="item_txt">售后</div>
                        </li>
                    </ul>
                </div>
                <div class="txt" name="b">
                    <ul class="actions">
                        <li class="item" @click="orderList(1)">
                            <img :src="this.publicPath+'statics/images/my/icon_wallet.png'" class="item_icon" alt="">
                            <div class="item_txt">待支付</div>
                            <div class="num" v-if="token && yunNum && yunNum.unpay_num!=0">{{ yunNum.unpay_num }}</div>
                        </li>
                        <li class="item" @click="orderList(2)">
                            <img :src="this.publicPath+'statics/images/my/icon_fahuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待发货</div>
                            <div class="num" v-if="token && yunNum && yunNum.unship_num!=0">{{yunNum.unship_num}}</div>
                        </li>
                        <li class="item" @click="orderList(3)">
                            <img :src="this.publicPath+'statics/images/my/icon_shouhuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待收货</div>
                            <div class="num" v-if="token && yunNum && yunNum.unreceipt_num!=0">{{ yunNum.unreceipt_num }}</div>
                        </li>
                        <li class="item" @click="orderList(4)">
                            <img :src="this.publicPath+'statics/images/my/icon_comment.png'" class="item_icon" alt="">
                            <div class="item_txt">待评论</div>
                        </li>
                        <li class="item" @click="afterSaleList(5)">
                            <img :src="this.publicPath+'statics/images/my/icon_aftersale.png'" class="item_icon" alt="">
                            <div class="item_txt">售后</div>
                        </li>
                    </ul>
                </div>
				<div class="txt" name="c">
                    <ul class="actions">
                        <li class="item" @click="orderDingzhiList(1)">
                            <img :src="this.publicPath+'statics/images/my/icon_wallet.png'" class="item_icon" alt="">
                            <div class="item_txt">待支付</div>
                            <div class="num" v-if="token && unpay_madeorders!=0">{{unpay_madeorders}}</div>
                        </li>
                        <li class="item" @click="orderDingzhiList(2)">
                            <img :src="this.publicPath+'statics/images/my/icon_order_dingzhi.png'" class="item_icon" alt="">
                            <div class="item_txt">定制中</div>
                            <div class="num" v-if="token && made_madeorders!=0">{{made_madeorders}}</div>
                        </li>
                        <li class="item" @click="orderDingzhiList(3)">
                            <img :src="this.publicPath+'statics/images/my/icon_order_dingzhi_weikuan.png'" class="item_icon" alt="">
                            <div class="item_txt">待付尾款</div>
                            <div class="num" v-if="token && unfinal_madeorders!=0">{{ unfinal_madeorders }}</div>
                        </li>
                        <li class="item" @click="orderDingzhiList(4)">
                            <img :src="this.publicPath+'statics/images/my/icon_shouhuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待收货</div>
							<div class="num" v-if="token && unship_madeorders!=0">{{ unship_madeorders }}</div>
                        </li>
                        <li class="item" @click="orderDingzhiList(5)">
                            <img :src="this.publicPath+'statics/images/my/icon_wancheng.png'" class="item_icon" alt="">
                            <div class="item_txt">已完成</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="list">
            <div class="title">平台服务</div>
            <div class="list_con_wrap">
				<ul class="list_con float" v-for="(list,index) in newList1" :key="index">
                    <li class="item" v-for="(item,index) in list" @click="goPage(item.path)" :key="'0'+index">
                        <img :src="item.icon" alt="" class="icon">
                        <div class="txt">{{item.title}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 合作伙伴 -->
        <!-- userrole.is_partner || userrole.is_agent || userrole.is_seller || userrole.is_tradesman || userrole.is_first_agent -->
        <div class="list" v-if="token && hasRole">
            <div class="title">合作伙伴</div>
            <ul class="list_con clearfix">
				<!-- 业务员特殊 1否2是 ;其他角色1是0否 -->
				<li class="item f-l" v-if="userrole.is_saleman == 2" @click="toSalesman">
                    <img :src="this.publicPath+ 'statics/images/my/icon_daili.png'" alt="" class="icon">
                    <div class="txt">业务员</div>
                </li>
                <li class="item f-l" v-if="userrole.is_agent" @click="goAgent(2)">
                    <img :src="this.publicPath+ 'statics/images/my/icon_daili.png'" alt="" class="icon">
                    <div class="txt">二级分销</div>
                </li>
				<li class="item f-l" v-if="userrole.is_first_agent" @click="goAgent(1)">
                    <img :src="this.publicPath+ 'statics/images/my/icon_daili.png'" alt="" class="icon">
                    <div class="txt">一级分销</div>
                </li>
                <li class="item f-l" v-if="userrole.is_tradesman" @click="goShopCenter('/tradesman/index')">
					<div class="icon_wrap">
						<img :src="this.publicPath+ 'statics/images/my/icon_shangpu.png'" alt="" class="icon">
						<div class="nums" v-if="token && trad_unship>0">{{ trad_unship }}</div>
					</div>
                    <div class="txt">店铺中心</div>
                </li>
                <li class="item f-l" v-if="userrole.is_seller" @click="goPage('/btob/index')">
					<div class="icon_wrap">
						<img :src="this.publicPath+ 'statics/images/my/icon_sqgongying.png'" alt="" class="icon">
						<div class="nums" v-if="token && seller_unship!=0">{{ seller_unship }}</div>
					</div>
                    <div class="txt">供应商</div>
                </li>
                <li class="item f-l" v-if="userrole.is_partner" @click="goPage('/partner/index')">
                    <img :src="this.publicPath+ 'statics/images/my/icon_hehuoren.png'" alt="" class="icon">
                    <div class="txt">城市合伙人</div>
                </li>
				<li class="item f-l" v-if="userrole.is_park" @click="goPage('/my/park/index')">
                    <img :src="this.publicPath+ 'statics/images/home/icon_yuanqu.png'" alt="" class="icon">
                    <div class="txt">园区</div>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
            ordertab: 'a',
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
            nums: {}, // 分享等信息
            hasRole: false, // 是否有角色
            userrole: {}, // 用户角色  "is_partner": 0, //是否是城市合伙人0否1是  "is_agent": 1,//是否是代理商户0否1是 "is_seller": 0,//是否是经销商0否1是  "is_tradesman": 0,//是否匠人0否1是
            useraccount: {}, //账户信息
            isClient: false, //是否在iOSAndroid客户端内显示
            token: null,
            cardMoney: '',
            tid: null, // 店铺&匠人相关信息
            imageUrl: Vue.prototype.$publicData.uploadImage,
            newList1: null, // 组装之后的 四个一组
            list1: [{
                    icon: process.env.BASE_URL + 'statics/images/my/icon_adress.png',
                    title: '收货地址',
                    path: '/user/adress'
                },
                {
                    icon: process.env.BASE_URL + 'statics/images/my/icon_yuekan.png',
                    title: '约看门票',
                    path: '/yuekan/order/index'
                },
                {
                    icon: process.env.BASE_URL + 'statics/images/my/icon_ziti.png',
                    title: '我的自提',
                    path: '/ziti/index'
                },
                {
                    icon: process.env.BASE_URL + 'statics/images/my/icon_quan.png',
                    title: '优惠券',
                    path: '/coupon/index'
				},
				{
					icon: process.env.BASE_URL + 'statics/images/my/icon_dingzhi.png',
                    title: '我的定制',
                    path: '/my/dingzhi/index'
				},
                {
                    icon: process.env.BASE_URL + 'statics/images/my/icon_invoice.png',
                    title: '我的发票',
                    path: '/user/invoice'
                },
				// {
                //     icon: process.env.BASE_URL + 'statics/images/my/icon_dingzhi_order.png',
                //     title: '定制订单',
                //     path: '/order/dingzhi/index'
				// },
                {
                    icon: process.env.BASE_URL + 'statics/images/my/icon_mycomment.png',
                    title: '我的评论',
                    path: '/comment/index'
				},
				{
                    icon: process.env.BASE_URL + 'statics/images/my/icon_myvideo.png',
                    title: '我的视频',
                    path: '/video/index'
				},
				{
                    icon: process.env.BASE_URL + 'statics/images/my/icon_myvideo.png',
                    title: '观看记录',
                    path: '/video/log'
                },
                {
                    icon: process.env.BASE_URL + 'statics/images/my/icon_xfjil.png',
                    title: '消费记录',
                    path: '/xiaofei/index'
                },
                {
                    icon: process.env.BASE_URL + 'statics/images/my/icon_quan.png',
                    title: '园区积分',
                    path: '/park/index'
				},
				{
                    icon: process.env.BASE_URL + 'statics/images/my/icon_piaoliu.png',
                    title: '我的漂流',
                    path: '/my/adrift/index'
                },
				{
                    icon: process.env.BASE_URL + 'statics/images/my/icon_ticket.png',
                    title: '园区票',
                    path: '/smartpark/order'
                },
				{
                    icon: process.env.BASE_URL + 'statics/images/my/icon_cika.png',
                    title: '我的次卡',
                    path: '/my/smartpark/card'
                }
            ],
            share: null, // 接口返回的分享内容 标题 描述 图像
            shareConfig: null, // 分享的相关配置
            is_cloud: 0, // 0商城1云订单
            unpay_num: null, // 待支付订单数量
            unreceipt_num: null, // 待收货订单数量
			unship_num: null, // 待发货订单数量
			trad_unship: null, // 店铺中心待发货数量(是商城订单+云订单+定制订单 的待发货总和)
			seller_unship: null, // 供应商待发货数量(只有商城订单,无云订单)
			unpay_madeorders: null, // 用户的待支付定制单
			made_madeorders: null, // 用户的定制中的定制单
			unfinal_madeorders: null, // 用户的待付尾款的定制单
			unship_madeorders: null, // 用户的待收货的定制单
			yunNum: null, // 云订单数据
        };
    },
    created: function () {
		localStorage.removeItem('orderStatus')
        this.getGroup()
    },
    mounted: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            // this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
            //     // alert(JSON.stringify(data));
            //     this.goPage('/set/index')
            //     responseCallback('success')
            // })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
			this.getData();
			// 不再区分云订单  2022年5月9号
			// this.getYunData()
			// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
            // this.getShareData()
        }
    },
	beforeRouteLeave (to, from, next) {
		// console.log('to===',to);
		if(to.name == "shop-order"){
			to.meta.isrefer = true;
		};
		next();
	},
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '我的',
                    'hiddenBack': true,
                    levitate: true,
                    showStatusBar: true,
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
					this.getData()
					// 不再区分云订单  2022年5月9号
					// this.getYunData()
                } else {
                    this.token = null
                    this.info = {}
                }
            })
        },
        changeTab: function (str) {
            this.ordertab = str
            $('.order .tab').removeClass('active')
            $('.order .txt').removeClass('active')
            $('.order .tab[name=' + str + ']').addClass('active')
            $('.order .txt[name=' + str + ']').addClass('active') 
			if (str == 'b') {
                this.is_cloud = 1
            }else{
				this.is_cloud = 0
			}
            // this.getData()
        },
        // 获取列表
        getData() {
            console.log('123')
            if (!this.token) {
                return
            }
            var params = {
                token: this.token,
                // is_cloud: 0 // 非云订单  不再区分云订单  2022年5月9号
            }
            this.$api.user.index(params).then(res => {
                console.log('res')
                console.log(res)
                if (res.code == 200) {
                    this.cardMoney = res.result.card_money
					this.info = res.result.info
					var nums = res.result.nums
					// 总收藏数 要加上定制收藏
					nums.collectAll = nums.collect + (res.result.madeAttention ? parseInt(res.result.madeAttention) : 0)
					this.nums = nums
                    this.useraccount = res.result.info.useraccount
                    this.userrole = res.result.info.userrole;
                    for(let i in this.userrole){
                        console.log(this.userrole[i],i);
						if(i == 'is_saleman'){
							if(this.userrole['is_saleman'] == 2){
								this.hasRole = true;
								break;
							};
						}else{
							if(this.userrole[i] == 1 && i != 'is_collector'){
								this.hasRole = true;
								break;
							}
						} 
                    };
                    this.tid = res.result.tid
                    this.share = res.result.share
                    var ordernum = res.result.ordernum
                    this.unpay_num = ordernum.unpay_num.toString().length > 2 ? ordernum.unpay_num.toString().slice(0, 2) + '..' : ordernum.unpay_num.toString()
                    this.unreceipt_num = ordernum.unreceipt_num.toString().length > 2 ? ordernum.unreceipt_num.toString().slice(0, 2) + '..' : ordernum.unreceipt_num.toString()
					this.unship_num = ordernum.unship_num.toString().length > 2 ? ordernum.unship_num.toString().slice(0, 2) + '..' : ordernum.unship_num.toString()
					var trad_unship = res.result.trad_unship
                    var trad_unship_made = res.result.trad_unship_made
					var seller_unship = res.result.seller_unship
					if(trad_unship == null || trad_unship == undefined || trad_unship == ""){
						trad_unship = 0
					} 
                    if(trad_unship_made == null || trad_unship_made == undefined || trad_unship_made == ""){
						trad_unship_made = 0
					}
                    this.trad_unship = trad_unship+trad_unship_made
					if (seller_unship) {
						this.seller_unship = seller_unship.toString().length > 2 ? seller_unship.toString().slice(0, 2) + '..' : seller_unship.toString()
					} else {
						this.seller_unship = 0
					}
					// 定制单
					this.unpay_madeorders = res.result.unpay_madeorders.toString().length > 2 ? res.result.unpay_madeorders.toString().slice(0,2)+ '..' : res.result.unpay_madeorders
					this.made_madeorders = res.result.made_madeorders.toString().length > 2 ? res.result.made_madeorders.toString().slice(0,2)+ '..' : res.result.made_madeorders
					this.unfinal_madeorders = res.result.unfinal_madeorders.toString().length > 2 ? res.result.unfinal_madeorders.toString().slice(0,2)+'...' : res.result.unfinal_madeorders
					this.unship_madeorders = res.result.unship_madeorders.toString().length > 2 ? res.result.unship_madeorders.toString().slice(0,2)+'...' :  res.result.unship_madeorders
                }
            })
		},
		// 获取云订单
		getYunData(){
			if (!this.token) {
                return
            }
            var params = {
                token: this.token,
                is_cloud: 1 // 云订单
            }
            this.$api.user.index(params).then(res => {
                console.log('res')
                console.log(res)
                if (res.code == 200) {
                   
					var ordernum = res.result.ordernum
					var yunNum = {}
                    yunNum.unpay_num = ordernum.unpay_num.toString().length > 2 ? ordernum.unpay_num.toString().slice(0, 2) + '..' : ordernum.unpay_num.toString()
                    yunNum.unreceipt_num = ordernum.unreceipt_num.toString().length > 2 ? ordernum.unreceipt_num.toString().slice(0, 2) + '..' : ordernum.unreceipt_num.toString()
					yunNum.unship_num = ordernum.unship_num.toString().length > 2 ? ordernum.unship_num.toString().slice(0, 2) + '..' : ordernum.unship_num.toString()
					this.yunNum = yunNum
                }
            })
		},
        // 查看订单
        orderList(status) {
            // console.log(this.ordertab)
            // if (this.ordertab == 'a') {
            if (this.isClient) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/shop/order?status=' + status
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                // 未登录状态
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath,
                        // }
                    })
                    return
                }
                // 跳转订单页面
                this.$router.push({
                    path: '/shop/order',
                    query: {
                        status: status
                    }
                })
            }
            // }
        },
        // 售后
        afterSaleList(status) {
            // if (this.ordertab == 'a') {
            if (this.isClient) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/shop/order/saled?status=' + status
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                // 未登录
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                // 售后
                this.$router.push({
                    path: '/shop/order/saled',
                    query: {
                        status: status
                    }
                })
            }

            // }
		},
		// 定制订单
		orderDingzhiList(status){
			if (this.isClient) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/order/dingzhi/index?status=' + status
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                // 未登录状态
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath,
                        // }
                    })
                    return
                }
                // 跳转订单页面
                this.$router.push({
                    path: '/order/dingzhi/index',
                    query: {
                        status: status
                    }
                })
            }
		},
        // 页面跳转
        goPage(path) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        //    console.log(this.$publicData.clientUrl)
                        //    return
                        var url = this.$publicData.clientUrl + path
                        if (path == 'login')
                        url = ''
                        var params = {
                            'data': {
                                'url': url
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    path: path
                })
            }
        },
        // 退出
        logout() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {
                        'forceLogin': 1,
                    }
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {

                })
            } else {
                this.$store.commit(LOGOUT);
                this.$router.push("/");
            }
        },
        // 店铺中心
        goShopCenter(path) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {

                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + path + `?tradesman_id=${this.tid.id}`
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    path: path,
                    query: {
                        tradesman_id: this.tid.id
                    }
                })
            }
        },
        // 四个一组，便于控制等距样式
        getGroup() {
            var result = []
            for (var i = 0; i < this.list1.length; i += 4) {
                result.push(this.list1.slice(i, i + 4))
            }
            this.newList1 = result
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.share.title, // 分享标题
                    desc: that.share.describe, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.info.thumb ? (that.$publicData.withHttpStart(that.info.thumb) ? that.info.thumb : that.imageUrl+that.info.thumb) : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
		},
		// 去一级/二级分销商页面
		goAgent(level){
			if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        //    console.log(this.$publicData.clientUrl)
                        //    return
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/agent/index?agent_level='+level
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                    })
                    return
                }
                this.$router.push({
					path: '/agent/index',
					query: {
						agent_level: level
					}
                })
            }
		},
		// 粉丝
		goFensi(){
			var that = this
			that.$router.push({
				path: '/fans/index',
				query: {
					tradesman_uuid : this.tid.uuid
				}
			})
		},
		/**
		 * @name: 跳转业务员
		 * @return {*}
		 * @desc: 
		 */		
		toSalesman(){
			this.$router.push({
				path: '/salesman/index'
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
